var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full flex items-center my-5 item-container cursor-pointer",on:{"click":() => _vm.onClick({ item: _vm.data })}},[_c('ProfilePicture',{staticClass:"mr-3 w-10",attrs:{"url":_vm.picture_url}}),_c('span',{staticClass:"item-label"},[_vm._v(_vm._s(_vm.firstName)+" "+_vm._s(_vm.lastName))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }